export default __webpack_public_path__ + "static/media/sha1_email.b1e4c1d7.csv";